import PropTypes from "prop-types";

export const HistoryContext = PropTypes.oneOf(["all", "submitted", "todo"]);

export const RoleID = PropTypes.oneOf(["AE", "Administrator", "CAE", "MED HW Eng"]);

export const SortDirection = PropTypes.oneOf(["asc", "desc"]);



// WEBPACK FOOTER //
// ./app/props/enums.js